module.exports = __webpack_public_path__ + "img/img_45.26ece403.png";